import React, {useState, useEffect, useContext, useCallback} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import FullBodyContentView from '../../views/fullBodyContentView';
import RunVerification from './run-verification';
import {useTranslation, withTranslation, Trans} from 'react-i18next';

function SMVComplete({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onLeft = useCallback(() => {
    onComponent(<RunVerification />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;
    onLeft();
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands({onLeft});
  }, [onLeft]);

  const {t, i18n} = useTranslation();
    const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  return (
    <FullBodyContentView
      title={t('smvRunVerif.a12')}
      fullCaption="Result...................................................
      ...Pass................................................
      .........................................................
      .........................................................
      .........................................................
      .........................................................

      "
    />
  );
}

export default SMVComplete;
